<template>
  <!--  电子发票预览 -->
  <Modal
    :value="showInvoice"
    width="1000"
    title="电子发票预览"
    @on-visible-change="(status)=>{$emit('visibleChange',status)}">
    <div id="invoice">
        <div style="color:red;padding:0 10px;">
            *请注意购买方名称，纳税人识别号，税率，价税合计，开票人等信息（此电子发票信息仅供预览参考）
        </div>
        <!-- <div style="margin-left:30px">
            @*<Checkbox v-model="ifShowInfo">发票显示购买方地址，电话，开户行及账号</Checkbox>*@
        </div> -->
        <div class="invoice-page">
            <div class="header">
                <div class="header-left">
                    <!-- 二维码 -->
                    <div style="width:66px;height:66px;"></div>
                    <div>
                        <span>机器编号：</span>
                        <input type="text" readonly v-model="invoiceData.robotNum">
                    </div>
                </div>
                <div class="header-img">
                    <img src="../../../../src/images/发票头部.png">
                </div>
                <div class="header-right">
                    <div>
                        <span>发票代码：</span>
                        <input type="text" readonly v-model="invoiceData.invoiceCode">
                    </div>
                    <div>
                        <span>发票号码：</span>
                        <input type="text" readonly v-model="invoiceData.invoiceNum">
                    </div>
                    <div>
                        <span>开票日期：</span>
                        <input type="text" readonly v-model="invoiceData.showInvoiceDate">
                    </div>
                    <div>
                        <span>校&nbsp;&nbsp;验&nbsp;码：</span>
                        <input type="text" readonly v-model="invoiceData.checkCode">
                    </div>
                </div>
            </div>
            <div class="table-data">
                <div class="tr tr1">
                    <div class="td td11">购买方</div>
                    <div class="td td12">
                        <div>
                            <span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</span>
                            <input type="text" style="width: 300px;" readonly v-model="invoiceData.buyerName">
                        </div>
                        <div>
                            <span>纳税人识别号：</span>
                            <input type="text" style="width: 300px;" readonly v-model="invoiceData.buyerCode">
                        </div>
                        <div>
                            <span>地址、&nbsp;&nbsp;&nbsp;电话：</span>
                            <input type="text" placeholder="地址"  v-model="invoiceData.buyerAddress" style="width: 200px;">
                            <input type="text" placeholder="电话"  v-model="invoiceData.buyerPhone" style="width: 100px;">
                        </div>
                        <div>
                            <span>开户行及账号：</span>
                            <input type="text" placeholder="开户行"  v-model="invoiceData.buyerAccountName" style="width: 200px;">
                            <input type="text" placeholder="账号"  v-model="invoiceData.buyerAccount" style="width: 100px;">
                        </div>
                    </div>
                    <div class="td td13">密码区</div>
                    <div class="td td14"></div>
                </div>
                <div class="tr tr2">
                    <div class="td td21">
                        <div>货物或应税劳务、服务名称</div>
                        <div>
                            <input type="text" readonly style="width: 190px;" v-model="invoiceData.goodsName">
                        </div>
                        <div style="position:absolute;bottom:0;width:200px">
                            <span>合&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计</span>
                        </div>
                    </div>
                    <div class="td td22">
                        <div>
                            <span>规格型号</span>
                            <input class="right-text" readonly style="width:55px;" type="text" v-model="invoiceData.goodsType">
                        </div>
                    </div>
                    <div class="td td23">
                        <div>
                            <span>单位</span>
                            <input class="right-text" readonly style="width:40px;" type="text" v-model="invoiceData.goodsUnit">
                        </div>
                    </div>
                    <div class="td td24">
                        <div>
                            <span>数&nbsp;&nbsp;量</span>
                            <input class="right-text" readonly style="width:85px;" type="text" v-model="invoiceData.goodsCount">
                        </div>
                    </div>
                    <div class="td td25">
                        <div>
                            <span>单&nbsp;&nbsp;价</span>
                            <input class="right-text" readonly style="width:90px;" type="text" v-model="invoiceData.goodsPrice">
                        </div>
                    </div>
                    <div class="td td26">
                        <div>
                            <span>金&nbsp;&nbsp;&nbsp;&nbsp;额</span>
                            <input class="right-text" readonly style="width:108px;" type="text" v-model="invoiceData.goodsTotalPrice">
                        </div>
                        <div style="position:absolute;bottom:0;width:112px">
                            <input class="right-text" readonly type="text" style="width:108px;" v-model="invoiceData.goodsTotalPriceTotal">
                        </div>
                    </div>
                    <div class="td td27">
                        <div>
                            <span>税率</span>
                            <input class="right-text" style="width:20px;" type="text" v-model="invoiceData.goodstax">
                            <span style="color:#000">%</span>
                        </div>
                    </div>
                    <div class="td td28">
                        <div>
                            <span>税&nbsp;&nbsp;&nbsp;&nbsp;额</span>
                            <input class="right-text" readonly style="width:115px;" type="text" v-model="invoiceData.goodsTaxPrice">
                        </div>
                        <div style="position:absolute;bottom:0;width:115px">
                            <input class="right-text" readonly type="text" style="width:115px;" v-model="invoiceData.goodsTaxPriceTotal">
                        </div>
                    </div>
                </div>
                <div class="tr tr3">
                    <div class="td td31">
                        <span>价税合计(大写)</span>
                    </div>
                    <div class="td td32">
                        <input type="text" readonly style="position:absolute;left:5px;top:9px;" v-model="invoiceData.totalUpperPrice">
                        <div style="position:absolute;left:365px;">
                            <span>(小写)</span>
                            <span style="color:#000;">￥</span>
                            <input type="text" style="width: 100px;" readonly v-model="invoiceData.totalLowerPrice">
                        </div>
                    </div>
                </div>
                <div class="tr tr4">
                    <div class="td td41">销售方</div>
                    <div class="td td42">
                        <div>
                            <span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</span>
                            <input type="text" readonly v-model="invoiceData.salesName">
                        </div>
                        <div>
                            <span>纳税人识别号：</span>
                            <input type="text" readonly v-model="invoiceData.salesCode">
                        </div>
                        <div>
                            <span>地址、&nbsp;&nbsp;&nbsp;电话：</span>
                            <input type="text" readonly v-model="invoiceData.salesAddressAndPhone" style="position:absolute;width:300px;" :title="invoiceData.salesAddressAndPhone">
                        </div>
                        <div style="position:relative">
                            <span>开户行及账号：</span>
                            <input type="text" readonly v-model="invoiceData.salesAccountAndName" style="position:absolute;width:300px;" :title="invoiceData.salesAccountAndName">
                        </div>
                    </div>
                    <div class="td td43">备<br /><br />注</div>
                    <div class="td td44"></div>
                </div>
            </div>
            <div style="position: relative;margin-top: 10px;">
                <div style="position: absolute;left: 45px;">
                    <span>收款人：</span>
                    <input type="text" placeholder="" v-model="invoiceData.payee">
                </div>
                <div style="position: absolute;left: 255px;">
                    <span>复核：</span>
                    <input type="text" style="width: 120px;" placeholder="" v-model="invoiceData.check">
                </div>
                <div style="position: absolute;left: 420px;">
                    <span>开票人：</span>
                    <input type="text" style="width: 100px;" placeholder="" v-model="invoiceData.drawer">
                </div>
                <div style="position: absolute;left: 580px;">
                    <span>销售方：(章)</span>
                </div>
            </div>
        </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
export default {
  props: {
    showInvoice: Boolean,
    data: Object
  },
  data() {
    return {
      invoiceData: {},
      invoiceForm: {}
    }
  },
  watch: {
    data(val) {
      this.invoiceData = val
    }
  }
};
</script>
<style scoped lang="less">
/deep/.ivu-modal {
  top: 40px;
}
#invoice {
  background: #ddd;
  padding: 5px 0;
  color: #9e520a;
}

#invoice .invoice-form {
  padding: 5px;
}

#invoice input {
  border: 0;
  height: 13px;
}

#invoice .right-text {
  text-align: right;
}

#invoice .invoice-page {
  width: 810px;
  height: 525px;
  margin: 20px auto;
  background: #fff;
  letter-spacing: 1px;
}

#invoice .invoice-page .header {
  position: relative;
  height: 110px;
  font-size: 12px;
}

#invoice .invoice-page .header .header-left {
  position: absolute;
  left: 40px;
  margin-top: 10px;
}

#invoice .invoice-page .header .header-img {
  position: absolute;
  left: 245px;
}

#invoice .invoice-page .header .header-right {
  position: absolute;
  left: 580px;
  margin-top: 10px;
  line-height: 23px;
}

#invoice .table-data {
  width: 800px;
  height: 350px;
  margin: 0 auto;
  box-sizing: border-box;
  border: 1px solid #a64d4d;
}

#invoice .table-data .tr + .tr {
  border-top: 1px solid #a64d4d;
}

#invoice .table-data .tr {
  box-sizing: border-box;
  font-size: 0;
}

#invoice .table-data .tr .td {
  display: inline-block;
  font-size: 12px;
  box-sizing: border-box;
  vertical-align: top;
}

#invoice .table-data .tr .td + .td {
  border-left: 1px solid #a64d4d;
}

#invoice .table-data .tr1 {
  word-wrap: break-word;
  text-align: center;
}

#invoice .table-data .tr1 .td {
  height: 80px;
}

#invoice .table-data .tr1 .td11 {
  width: 25px;
  padding-top: 12px;
}

#invoice .table-data .tr1 .td12 {
  width: 410px;
  text-align: left;
  padding-left: 5px;
  line-height: 20px;
}

#invoice .table-data .tr1 .td13 {
  width: 20px;
  padding-top: 12px;
}

#invoice .table-data .tr1 .td14 {
  width: 303px;
}

#invoice .table-data .tr2 {
  text-align: center;
}

#invoice .table-data .tr2 .td {
  height: 165px;
}

#invoice .table-data .tr2 .td21 {
  position: relative;
  width: 200px;
}

#invoice .table-data .tr2 .td22 {
  width: 60px;
}

#invoice .table-data .tr2 .td23 {
  width: 45px;
}

#invoice .table-data .tr2 .td24 {
  width: 90px;
}

#invoice .table-data .tr2 .td25 {
  width: 95px;
}

#invoice .table-data .tr2 .td26 {
  width: 113px;
  position: relative;
}

#invoice .table-data .tr2 .td27 {
  width: 35px;
}

#invoice .table-data .tr2 .td28 {
  width: 120px;
  position: relative;
}

#invoice .table-data .tr3 {
  text-align: center;
}

#invoice .table-data .tr3 .td {
  height: 30px;
  line-height: 30px;
}

#invoice .table-data .tr3 .td31 {
  width: 200px;
}

#invoice .table-data .tr3 .td32 {
  position: relative;
  width: 557px;
  text-align: left;
}

#invoice .table-data .tr4 {
  text-align: center;
}

#invoice .table-data .tr4 .td {
  height: 71px;
}

#invoice .table-data .tr4 .td41 {
  letter-spacing: 4px;
  padding: 8px 0 0 4px;
  width: 30px;
}

#invoice .table-data .tr4 .td42 {
  width: 400px;
  text-align: left;
  padding-left: 5px;
  line-height: 18px;
}

#invoice .table-data .tr4 .td42 input {
  width: 200px;
}

#invoice .table-data .tr4 .td43 {
  padding-top: 8px;
  width: 20px;
}

#invoice .table-data .tr4 .td44 {
  width: 307px;
}

#invoice .operate-invoice {
  margin: 30px;
}
</style>
